import { CommonModule } from '@angular/common';
import { CustomizeRangePickerComponent } from './customize-range-picker.component';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';

@NgModule({
    declarations: [CustomizeRangePickerComponent],
    imports: [
        CommonModule,
        FormsModule,
        NzDatePickerModule,
    ],
    exports: [CustomizeRangePickerComponent],
})
export class CustomizeRangePickerModule {}
